import {BaseDashlet} from "../../lq_js_common/dashboard/base_dashlet";
import {DashboardGraph} from "../../graphs/dashboard_graph";

export class ShaperCircuitAsnMap extends BaseDashlet {
    constructor(slot, direction = "download") {
        super(slot);
        this.rendered = false;
        this.lastGraphState = null;
        this.direction = direction;
    }

    title() { return this.direction === 'upload' ? "Circuit World Traffic Map (Upload)" : "Circuit World Traffic Map (Download)"; }
    supportsZoom() { return true; }
    tooltip() { return "<h5>Circuit World Map</h5><p>Where this circuit's traffic is going/coming.</p>"; }

    buildContainer() { let base = super.buildContainer(); base.appendChild(this.graphDiv()); return base; }
    setup() { super.setup(); this.graph = new CircuitAsnMapGraph(this.graphDivId()); if (this.lastGraphState) this.graph.update(this.lastGraphState); }
    channelRequests() { return ["CircuitLocation"]; }

    onMessage(msg) {
        if (!msg.Data || msg.Data.target !== "circuit_location") return;
        const rows = msg.Data.blob.rows || [];
        const points = rows.map(r => [r.longitude, r.latitude, this.direction === 'upload' ? Number(r.bytes_up) : Number(r.bytes_down)]);

        const myDiv = document.getElementById(this.id);
        if (!this.rendered) { myDiv.classList.add("card", "animate__animated", "animate__fadeIn"); }
        else { myDiv.classList.add("animate__animated", "animate__pulse"); setTimeout(() => myDiv.classList.remove("animate__animated", "animate__pulse"), 1000); }

        this.graph.update(points);
        this.lastGraphState = points;
        this.rendered = true;
    }
}

class CircuitAsnMapGraph extends DashboardGraph {
    constructor(id) {
        super(id);
        this.useWebGL = supportsWebGL();
        this.option = {
            backgroundColor: '#000000',
            geo: {
                map: 'world', roam: false, label: { emphasis: { show: false } }, silent: true,
                itemStyle: { normal: { areaColor: '#323c48', borderColor: '#111' }, emphasis: { areaColor: '#2a333d' } }
            },
            series: [ { type: this.useWebGL ? 'scatterGL' : 'scatter', coordinateSystem: 'geo', blendMode: 'lighter', lineStyle: { width: 0.2, opacity: 0.05 }, symbolSize: [], data: [] } ]
        };
        this.chart.setOption(this.option);
    }

    update(data) {
        this.chart.hideLoading();
        this.option.series[0].data = data;
        let maxValue = 0;
        data.forEach(p => { if (p[2] > maxValue) maxValue = p[2]; });
        const computeSize = (value) => {
            if (maxValue <= 0) return 1;
            let size = 8 * (value / maxValue);
            return Math.max(1, parseInt(size));
        };
        if (this.useWebGL) {
            this.option.series[0].symbolSize = data.map(p => computeSize(p[2]));
        } else {
            this.option.series[0].symbolSize = (val) => {
                const value = Array.isArray(val) ? (val[2] || 0) : 0;
                return computeSize(value);
            };
        }
        this.chart.setOption(this.option);
    }
}

function supportsWebGL() {
    try {
        const canvas = document.createElement('canvas');
        return !!(window.WebGLRenderingContext && (canvas.getContext('webgl') || canvas.getContext('experimental-webgl')));
    } catch (e) {
        return false;
    }
}
